import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { installAppImageBridge } from '@/utils/appMedia';
installAppImageBridge();
function showBootError(message) {
    const root = document.getElementById('app');
    if (!root)
        return;
    root.innerHTML = `<div style="display:flex;align-items:center;justify-content:center;min-height:100vh;padding:24px;box-sizing:border-box;color:#ff4d4f;font:14px/1.5 -apple-system,BlinkMacSystemFont,sans-serif;text-align:center;">${message}</div>`;
}
window.addEventListener('error', (event) => {
    const detail = event.message ||
        (event.filename ? `${event.filename}${event.lineno ? `:${event.lineno}` : ''}` : '');
    if (detail)
        showBootError(`页面加载失败：${detail}`);
});
window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason ?? '未知错误');
    showBootError(`页面运行异常：${message}`);
});
router.onError((err) => {
    showBootError(`资源加载失败，请刷新重试：${err.message}`);
});
createApp(App).use(router).mount('#app');
